import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { setup } from "@setup";

setup();
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);
